import React from 'react'
import { SubtotalProps } from '../../lib/type'
import { useTranslation } from 'next-i18next'
import {
    BundleItemOption,
    Maybe,
    ProductInterface
} from '@pylot-data/fwrdschema'
import { formatPrice } from '@corratech/pylot-price'
import ds from '../DeviceSelection/DeviceTile.module.scss'
import { useRouter } from 'next/router'
import cn from 'classnames'

export const Subtotal = ({
    product,
    selectedOptions,
    addOns,
    isSubscribed,
    podsPrice = 0
}: SubtotalProps): JSX.Element => {
    const { t } = useTranslation(['common', 'plp'])
    const { locale } = useRouter()
    const options: {
        [key: string]: { sku: string; ooka_product_option: string }
    } = {}
    const selectedProducts =
        product?.items?.flatMap((item) => {
            return item?.options?.filter((option) => {
                if (selectedOptions?.includes(option?.uid!)) {
                    const sku = option?.product?.sku!
                    options[sku] = {
                        sku: option?.product?.sku!,
                        ooka_product_option: item?.ooka_product_option!
                    }
                    return true
                }
                return false
            })
        }) ?? []
    const adonProducts: Maybe<ProductInterface>[] | undefined =
        product?.upsell_products?.filter((individualProduct) => {
            return addOns && addOns[individualProduct?.sku!]?.qty
        }) ?? []
    const pods = product?.items?.filter(
        (item) => item?.ooka_product_option == 'pods'
    )
    const devicePrice = selectedProducts?.reduce(
        (accumulate: number, item?: Maybe<BundleItemOption> | number) => {
            const price =
                typeof item == 'object'
                    ? (item?.product?.price_range?.minimum_price?.final_price
                          ?.value as number)
                    : 0

            return Math.round(price) + accumulate
        },
        0
    )
    const adonPrice = adonProducts?.reduce(
        (accumulate: number, item?: Maybe<ProductInterface> | number) => {
            const price =
                (typeof item == 'object'
                    ? (item?.price_range?.minimum_price?.final_price
                          ?.value as number)
                    : 0) *
                (addOns?.[typeof item == 'object' ? item?.sku! : '']?.qty ?? 1)
            return Math.round(price) + accumulate
        },
        0
    )

    const totalPrice = (
        <span className={ds['price-ammount']}>
            {formatPrice(
                {
                    value: Math.round(devicePrice) + adonPrice + podsPrice,
                    currency:
                        product?.price_range.minimum_price?.final_price
                            ?.currency
                },
                locale!
            )}
        </span>
    )

    return (
        <div className={cn(ds['price'], 'subtotal-price')}>
            <h5 className={ds['price-label']}>
                {' '}
                {t('Subtotal: ')} {totalPrice}
            </h5>
        </div>
    )
}
